import config from "../config";
const CLIENT_ID = config.miniAppId;
try {
    window.miniapp = new window.hamromini_sdkjs.MiniApp();
} catch (e) {

}

export function initializer() {
    return new Promise(async (resolve, reject) => {
        window.hamromini_sdkjs.initialize(CLIENT_ID, window.miniapp)
            .then((userDetails) => {
                resolve(userDetails);
            })
            .catch((e) => {
                reject(e);
            });
    });
}
